const config = {
    showResultScore: parseInt(process.env.VUE_APP_SHOW_RESULT_SCORE, 10) > 0,
    apiBaseUrl: process.env.VUE_APP_BASE_API_URL.replace(/\/+$/, ''),
};

export default config;
